export enum ProgrammeTypes {
  TWO_YEAR_FULL_TIME_MPHIL = 'TWO_YEAR_FULL_TIME_MPHIL',
  FOUR_YEAR_PART_TIME_MPHIL = 'FOUR_YEAR_PART_TIME_MPHIL',
  THREE_YEAR_FULL_TIME_PHD = 'THREE_YEAR_FULL_TIME_PHD',
  SIX_YEAR_PART_TIME_PHD = 'SIX_YEAR_PART_TIME_PHD',
  FOUR_YEAR_FULL_TIME_PHD = 'FOUR_YEAR_FULL_TIME_PHD',
  EIGHT_YEAR_PART_TIME_PHD = 'EIGHT_YEAR_PART_TIME_PHD',
}

export const fullTimeDurationMap: Partial<Record<ProgrammeTypes, number>> = {
  [ProgrammeTypes.TWO_YEAR_FULL_TIME_MPHIL]: 2,
  [ProgrammeTypes.THREE_YEAR_FULL_TIME_PHD]: 3,
  [ProgrammeTypes.FOUR_YEAR_FULL_TIME_PHD]: 4,
};

export enum OfferSuggestion {
  CONDITIONAL = 'Conditional',
  FIRM = 'Firm',
  REJECT = 'Reject',
  NOT_RECOMMENDED = 'Not recommended',
}

export enum PreliminaryCheckResult {
  PASS = 'Pass',
  PENDING = 'Pending',
  FAIL = 'Fail',
}
